import { useTranslation } from 'react-i18next';

import { getPluralKey } from '@common/helpers/getPluralKey';
import * as Yup from 'yup';

const changePasswordModalValidation = () => {
	const { t } = useTranslation();
	return Yup.object().shape({
		old_password: Yup.string().required(t('validationMessages.mandatory')),
		password: Yup.string()
			.required(t('validationMessages.mandatory'))
			.min(8, t(`validationMessages.minCharacters.${getPluralKey(8)}`, { min: 8 }))
			.matches(/[a-z]/, t('validationMessages.lowercaseLetter'))
			.matches(/[A-Z]/, t('validationMessages.uppercaseLetter')),
		password_confirmation: Yup.string()
			.required(t('validationMessages.mandatory'))
			.oneOf([Yup.ref('password'), null], t('validationMessages.passwordMatch')),
	});
};

export default changePasswordModalValidation;
